import React from 'react';
import '../MenuFooter/style.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logout } from 'stores/User/userActions';
import SubscribersList from '../user_menu/SubscribersList';
import Modal from '../../../ui_elements/Modal';

const AccountSwitcher = ({
  subscribersList,
  showSubscribersAccountsModal,
  toggleNav,
}) => {
  return (
    <Modal type="withShadow" close={showSubscribersAccountsModal} size={500} customClass='switchAcc-modal'>
      {subscribersList ? (
        <SubscribersList
        customClass={['switchAcc-modal']}
          subAccountsList={subscribersList}
          showSubscribersAccountsModal={showSubscribersAccountsModal}
          toggleNav={toggleNav}
        />
      ) : (
        ''
      )}
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    subscribersList: state.user.subscribersList,
    selectedSubscriber: state.user.selectedSubscriber,
    links: state.layout.routes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ logout }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSwitcher);
